import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Map, Calendar } from "lucide-react";
import { cn } from "@/lib/utils";
export interface HuntTypeProps {
  title: string;
  season?: string;
  description: string;
  huntingArea?: string;
  successRate?: number;
  isSelected?: boolean;
  onClick: () => void;
}
export const HuntTypeCard: React.FC<HuntTypeProps> = ({
  title,
  season,
  description,
  huntingArea,
  successRate,
  isSelected = false,
  onClick
}) => {
  return <Card className={cn("cursor-pointer transition-all duration-200 hover:shadow-md border-2", isSelected ? "border-tribal-primary bg-tribal-primary/5" : "border-tribal-neutral/20 hover:border-tribal-primary/50")} onClick={onClick}>
      
    </Card>;
};